import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch, onBeforeMount, onUnmounted } from 'vue';
import { NSpace, NImage, NButton, NInputGroup, NCard, useDialog } from 'naive-ui';
import getBase from '@/utils/base';
import $msg from '@/utils/message';
import { v4 as uuidv4 } from 'uuid';
import { closeWebSocket, sendWebSocket } from '@/utils/wxWebsocket';

export default /*#__PURE__*/_defineComponent({
  __name: 'WxBindComp',
  emits: ['close'],
  setup(__props, { emit: emits }) {


const { $api, $router, $store, t, reInitAuth } = getBase();
let param = ref({
	openId: '',
	scene: uuidv4().replaceAll("-", '')
});

const connectStatus = computed(() => $store.state.wxWs.connectStatus);
onBeforeMount(() => {
	connectWs();
})
onUnmounted(() => {
	closeWebSocket();
})

let wxBindQrcodeUrl = computed(() => {
	return $api.commonUrl.wxBindQrcode(param.value.scene);
})

function refreshFun() {
	param.value.scene = uuidv4().replaceAll("-", '');
}

function connectWs() {
	closeWebSocket();
	sendWebSocket("00000000", getAlarmData, $api.commonUrl.wxWebsocket(param.value.scene));
}

watch(() => param.value.scene, (newValue, oldValue) => {
	closeWebSocket();
	if (null != newValue) {
		sendWebSocket("00000000", getAlarmData, $api.commonUrl.wxWebsocket(newValue));
	}
});
const dialog = useDialog();
window.addEventListener('onmessageWS', getSocketData);
function getSocketData(res: any) {
	let data = JSON.parse(res.detail.data);
	let dataType = data.type;
	console.log(data);
	if ('WX_BIND' == dataType) {
		param.value.openId = data.data.openId;
		if (data.data.unbind) {
			dialog.warning({
				title: t('warning'),
				content: t('tip.wx_unbind'),
				positiveText: t('confirm'),
				negativeText: t('cancel'),
				onPositiveClick: () => {
					wxBind();
				},
				onNegativeClick: () => {
					closeWebSocket();
					emits('close');
				}
			})
		} else {
			wxBind();
		}
	}
}
// 获取到返回的数据
const getAlarmData = (data: any) => {
	console.log("getAlarmData", data);
}
const wxBind = function () {
	$api.common.wxBind(param.value).then((res: any) => {
		console.log(res);
		param.value.openId = res.openId;
		closeWebSocket();
		$msg.success(t('bind') + ' ' + t('success'));
		reInitAuth();
		emits('close');
	});
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NCard), {
    "header-style": "color:red;text-align:center;",
    style: {"max-width":"500px","margin":"0 auto"}
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NSpace), {
        vertical: "",
        style: {"gap":"20px 15px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NSpace), null, {
            default: _withCtx(() => [
              _createVNode(_unref(NImage), {
                class: _normalizeClass({ blur: !_unref(connectStatus) }),
                src: _unref(wxBindQrcodeUrl),
                "preview-disabled": ""
              }, null, 8, ["class", "src"])
            ]),
            _: 1
          }),
          _createVNode(_unref(NSpace), { justify: "end" }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NButton), {
                    style: {"margin-right":"5px"},
                    text: "",
                    tag: "a",
                    onClick: refreshFun,
                    type: "primary",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('refresh')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})